<template>
  <div class="related-items">
    <LoadSpinner v-if="loading"/>
    <div class="related-items__grid">
      <div
        v-for="item in items"
        :key="item.mpc_asuntoid || item.mpc_kohdeid"
        class="related-items__column"
      >
        <component
          :is="cardComponent"
          v-bind="cardProps(item)"
          class="related-items__card print-break-before"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  import globals from '../lib/globals';
  import HousingLocalityCard from './components/HousingLocalityCard';
  import ApartmentCard from './components/ApartmentCard';
  import LoadSpinner from './components/LoadSpinner';

  export default {
    components: {
      LoadSpinner,
      HousingLocalityCard,
      ApartmentCard,
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      uuid: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        items: [],
      };
    },
    computed: {
      cardComponent() {
        return {
          apartment: ApartmentCard,
          housingLocality: HousingLocalityCard,
        }[this.type];
      },
    },
    methods: {
      cardProps(item) {
        const propName = {
          apartment: 'apartment',
          housingLocality: 'housingLocality',
        }[this.type];

        return propName ? { [propName]: item } : {};
      },
    },
    async beforeMount() {
      const endpoint = {
        apartment: 'apartments-related', // todo
        housingLocality: 'housinglocalities-related',
      }[this.type];

      this.loading = true;
      const url = `${globals.urlIntegrationApi}/public/${endpoint}/${this.uuid}`;
      const response = await axios.get(url);
      this.items = response.data;
      this.loading = false;
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .related-items {
    @include prevent-margin-collapse;
    padding: 0 r(4);
    margin: 0 auto;
    max-width: r(360);

    @include media-breakpoint-up(md) {
      max-width: r(720);
    }

    @include media-breakpoint-up(xl) {
      max-width: r(1080);
    }

    @include media-breakpoint-up(xxl) {
      max-width: r(1440);
    }
  }

  .related-items__grid {
    display: flex;
    flex-wrap: wrap;
    margin: r(-4) 0;

    // Nicer positioning for when there are less than 4 items. This kind of "optimization" doesn't work well with
    // wrapped items so it's only applied to breakpoints that don't have wrapping.
    @include media-breakpoint-up(xl) {
      justify-content: center;
    }
  }

  .related-items__column {
    display: flex;
    padding: .75rem;
    width: 100%;

    @include media-breakpoint-up(md) {
      width: percentage(calc(1 / 2));
    }

    @include media-breakpoint-up(xl) {
      width: percentage(calc(1 / 3));
    }

    @include media-breakpoint-up(xxl) {
      width: percentage(calc(1 / 4));
    }

    // Hide the lone wrapped item. This covers all the cases with exactly 4 items.
    &:nth-child(4) {
      @include media-breakpoint-only(xl) {
        display: none;
      }
    }
  }

  .related-items__card {
    flex: 1 0 100%;
  }
</style>
